/*
 * Copyright (c) 2023. Data Smart Technologies CC
 * https://www.datasmart.co.za
 * View license agreement and terms of use at https://www.datasmart.co.za/legal
 *
 * @author  Juan <juan@datasmart.co.za>
 * @version 1.0
 * @updated 2023-06-29
 */

import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { QueryListProvider } from "../../../component/solution/QueryList/QueryListContext";
import { QueryList } from "../../../component/solution/QueryList/QueryList";

export const Supplier: React.FC = () => {

    return(
        <React.Fragment>
            <Container fluid className="p-0">

                {/* Query List Here */}
                <QueryListProvider>
                    <QueryList 
                        listTitle={"Supplier"}
                        recordTitle={"Supplier"}
                        tableName={"sa_vendor"} 
                        editTableName={"sa_vendor"}
                        editHasCompoundKey={false}
                        join={[
                        ]} 
                        select={[                                                                                                                              
                            {
                                fullColumnName : "vendor_id",
                                aggregate: ""
                            },                                
                            {
                                fullColumnName : "co_name",
                                aggregate: ""
                            },
                            {
                                fullColumnName : "contact",
                                aggregate: ""
                            },
                            {
                                fullColumnName : "phone",
                                aggregate: ""
                            },
                            {
                                fullColumnName : "terms",
                                aggregate: ""
                            }
                        ]}
                        where={[]} 
                        orderBy={[    
                            // {
                            // fullColumnName: "ship_date",
                            // direction: "DESC",
                            // cast: CastType.DATE
                            // }
                        ]} 
                        groupBy={[]}                    
                    />
                </QueryListProvider> 
            </Container>
        </React.Fragment>
    );
}